export default function getData() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Autotrader',
    alternateName: 'Autotrader',
    url: 'https://www.autotrader.com/'
  };
}